let _handlers = null;

export function setShapeHandlers(handlers) {
  _handlers = handlers;
}

export function getShapeHandlers() {
  return _handlers;
}
